import React from 'react';
import { useStyles } from './ZoneListItem.styles';
import { imageZone, zoneDragItemType } from '../ZonesList.types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TooltipOne from '../../../../../components/TooltipOne/TooltipOne.component';
import ZonePreview from '../../ZonePreview/ZonePreview.component';
import { useDrag, DragSourceMonitor } from 'react-dnd';
import { ZoneDropArea } from './ZoneDropArea.component';

interface ZonesListItemProps {
  zone: imageZone;
  isActive: boolean;
  wholeImageData: Blob;
  onClickZone: (zone: imageZone) => void;
  onDeleteButtonClick: (zone: imageZone) => void;
  onDropZone: (draggedZone: imageZone, targetZone: imageZone | null) => void;
}

export const ZonesListItem: React.FC<ZonesListItemProps> = ({
  zone,
  wholeImageData,
  isActive,
  onClickZone,
  onDeleteButtonClick,
  onDropZone,
}) => {
  const classes = useStyles();

  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: zoneDragItemType.ZONE,
      item: zone,
      collect: (monitor: DragSourceMonitor<imageZone, unknown>) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [zone],
  );


  return (
    <ZoneDropArea zone={zone} onDropZone={onDropZone}>
      <>
        <div className={classes.zoneOrder}>{zone.orderNumber + 1}</div>
        <div className={classes.zoneImageWithDeleteButton}>
          <div ref={dragRef} className={isDragging ? classes.draggingZone : undefined}>
            <ZonePreview
              className={isActive ? [classes.zoneImg, classes.zoneImgActive].join(' ') : classes.zoneImg}
              wholeImageData={wholeImageData}
              zone={zone}
              canvasWidth={450}
              onClick={() => onClickZone(zone)}
              title={`Strefa obrazu - obszar ${zone.orderNumber + 1}`}
            />
          </div>
          {isActive && (
            <TooltipOne title="Usuń" placement="top">
              <IconButton
                disableRipple
                aria-label={`Usuń obszar ${zone.orderNumber + 1}`}
                size="small"
                className={classes.removeButton}
                onClick={() => onDeleteButtonClick(zone)}
              >
                <CloseIcon />
              </IconButton>
            </TooltipOne>
          )}
        </div>
      </>
    </ZoneDropArea>
  );
};
